import React from 'react';
import PropTypes from 'prop-types';
import { StyleButton } from './StyleButton';

const StyleControls = ({ editorState, onToggle, types }) => {
  const selection = editorState.getSelection();
  const blockType = editorState
    .getCurrentContent()
    .getBlockForKey(selection.getStartKey())
    .getType();

  return (
    <div className="RichEditor-controls">
      {types.map(type => (
        <StyleButton
          key={type.style}
          active={type.style === blockType}
          onToggle={onToggle}
          style={type.style}
          iconName={type.iconName}
        />
      ))}
    </div>
  );
};

StyleControls.propTypes = {
  editorState: PropTypes.object.isRequired,
  onToggle: PropTypes.func.isRequired,
  types: PropTypes.array.isRequired
};

export default StyleControls;



// WEBPACK FOOTER //
// ./src/component/TextEditor/StyleControls.js